import { URL } from '../constants';

export async function handCopyLinkCall(token){
    const { videoCall } = URL;
    const link = `${videoCall}${token}`;
    return await navigator.clipboard.writeText(link)
        .then(() => {
            return true;
        })
        .catch(err => {
            return false;
        });
};
